// ============================================================
// Reading documents from photos (#70): CMR, weighbridge ticket or
// delivery note → fields, compared with the loading. The comparison
// runs in code (not by the model), so a mismatch is never invented.
// Plain JS: the Worker imports the demo and the comparison.
// ============================================================

const norm = (s) => String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
const WEIGHT_TOLERANCE_T = 0.5;

// [{ field, onDoc, expected, ok }] for the fields the document has.
export function compareWithLoading(fields, loading) {
  const out = [];
  if (fields.plate) out.push({ field: 'plate', onDoc: fields.plate, expected: loading.plate, ok: norm(fields.plate) === norm(loading.plate) });
  if (fields.orderId) out.push({ field: 'orderId', onDoc: fields.orderId, expected: loading.orderId, ok: norm(fields.orderId) === norm(loading.orderId) });
  if (fields.weightT != null) {
    out.push({ field: 'weight', onDoc: `${fields.weightT} t`, expected: `${loading.weight} t`, ok: Math.abs(fields.weightT - loading.weight) <= WEIGHT_TOLERANCE_T });
  }
  return out;
}

// Prepared answer without a key: a weighbridge ticket for this loading, 1.2 t short.
export function docReadDemo({ loading }) {
  const fields = {
    plate: loading.plate, orderId: loading.orderId, weightT: Math.round((loading.weight - 1.2) * 10) / 10,
    date: new Date().toISOString().slice(0, 10), carrier: loading.carrier,
  };
  return { docType: 'weighbridge', fields, checks: compareWithLoading(fields, loading), notes: '' };
}
